import React,{Component} from 'react';
import {PostData} from '../../../service/postData';
import {sendNotification} from '../../../_notificationSettings/notificationPanel';
import { MDBDataTableV5 } from 'mdbreact';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

global.BACK_URL = 'Business';

let columns = [
    {
        label: '#',
        field: 'srNo',
        width: 20,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': '',
        },
    },
    {
        label: 'Setup Plan Title',
        field: 'title',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Setup Plan Title',
        },
    },
    {
        label: 'Setup Plan Amount',
        field: 'setup_amount',
        width: 30,
    },
    {
        label: 'Added',
        field: 'added_on',
        width: 150,
    },
    {
        label: 'Status',
        field: 'status',
        width: 100,
    },
    {
        label: 'Action',
        field: 'action',
        width: 100,
    }
];

let _loader = 'glb-ldr-prt active';

export default class blogListPanel extends Component{
    constructor(props){
        super(props);
        this.state = {
            isLoaded : true,
            setupArray :[],
        }
    }

    componentDidMount ()
    {
        this.getSetupPlanListData();
    }

    getSetupPlanListData(){
        let _setupArray = [];
        let _url_GetData = global.adminSetupPlanList;
        PostData(_url_GetData,'','POST').then(result => {
            let responseJson = result;
            if(responseJson.success == false)
            {  
                this.setState({isLoaded:true});                
            }
            else
            {
                if (responseJson.response) {
                    _setupArray = responseJson.response;
                }
                this.setState({setupArray:_setupArray,isLoaded:true});               
            }             
        })
        .catch(error => this.setState({ error, isLoaded: false }));
    }

    clickToDelete(value)
    {
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure you want to delete?',
            buttons: [
            {
                label: 'Yes',
                className: 'btn btn-danger',
                onClick: () => {
                    const requestData = JSON.stringify({
                        setupId: value
                    });
                    PostData(global.setupPlanDelete, requestData,'POST').then((result) => {
                        let responseJson = result;                
                        if(responseJson.success == false)
                        {
                            sendNotification("Error Message 😓",responseJson.message,"danger");
                            return;
                        }
                        else
                        {
                            sendNotification("Welcome Back  👍",responseJson.message,"success");
                            this.getSetupPlanListData();
                            return;
                        }
                    });
                }
            },
            {
                label: 'No',
                className: 'btn btn-dark',
            }
            ]
        });
    }
    clickToStatus(value,_status)
    {
        confirmAlert({
            title: 'Confirm to manage status',
            message: 'Are you sure you want to change the status?',
            buttons: [
            {
                label: 'Yes',
                className: 'btn btn-danger',
                onClick: () => {
                    const requestData = JSON.stringify({
                        setupId: value,
                        status:_status
                    });
                    PostData(global.setupPlanStatus, requestData,'POST').then((result) => {
                        let responseJson = result;                
                        if(responseJson.success == false)
                        {
                            sendNotification("Error Message 😓",responseJson.message,"danger");
                            return;
                        }
                        else
                        {
                            sendNotification("Welcome Back  👍",responseJson.message,"success");
                            this.getSetupPlanListData();
                            return;
                        }
                    });
                }
            },
            {
                label: 'No',
                className: 'btn btn-dark',
            }
            ]
        });
    }

    loadBlogListing()
    {   
        if(this.state.isLoaded == true)
        {
            let _setupDetails = this.state.setupArray;
            let dataList = [];
            let rows = [];

            if(_setupDetails.length > 0)
            {                          
                _setupDetails.map((blogDatas, i) =>
                {
                    const row = blogDatas;

                    let _status = 1;
                    let status = <span className={`badge badge-danger`}>Disabled</span>;
                    if (row.status == '1') {
                        _status = 0;
                        status = <span className={`badge badge-success`}>Enabled</span>;
                    }
        
                    let _dtt = row.added_on;
                    var options = {year: 'numeric', month: 'long', day: 'numeric' };
                    
                    rows.push({
                        title: (row.setup_plan_title),
                        //description: atob(row.setup_plan_description),
                        setup_amount: row.setup_plan_amount,
                        srNo: row.srNo,
                        status: (status),
                        added_on: new Intl.DateTimeFormat('en-US', options).format(_dtt),
                        action:(
                            <div className="btn-group" role="group">
                                <button type="button" className="btn btn-secondary dropdown-toggle" id="btnGroupVerticalDrop3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="si si-list"></i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                                    <a className="dropdown-item" href={global.webUrl+'administrator/add-setup-plan/?auth='+row.id}>
                                        <i className="si si-pencil mr-5 text-info"></i>Edit Details
                                    </a>
                                    <a className="dropdown-item" href="javascript:void(0)" data-id={row.id} onClick={this.clickToStatus.bind(this,row.id,_status)}>
                                        <i className="fa fa-exclamation-triangle mr-5 text-primary"></i>Manage Status
                                    </a>
                                    {/* <a className="dropdown-item" href="javascript:void(0)" data-id={row.id} onClick={this.clickToDelete.bind(this,row.id)}>
                                        <i className="si si-trash mr-5 text-danger"></i>Delete Details
                                    </a> */}
                                </div>
                            </div>
                        )
                    });
                })
            }

            if (rows) {
                dataList = {
                    columns: columns,
                    rows: rows
                };
            }
            return dataList;
        }
    }

    render(){
        if(this.state.isLoaded == true){
            _loader = 'glb-ldr-prt';
        }

        return(
            <React.Fragment>
                <div className="content">
                    <div className="content-header">
                        <div className="header-section">
                            <h1 className="content-heading">
                                <i className="gi gi-direction"></i>Manage Setup Plan List<br/>
                            </h1>
                        </div>
                    </div>
                    <nav className="breadcrumb push">
                        <a className="breadcrumb-item" href={global.webUrl+"administrator/dashboard/"}>Dashboard</a>
                        <a className="breadcrumb-item" href={global.webUrl+"administrator/add-setup-plan/"}>Add New Setup Plan</a>
                        <span className="breadcrumb-item active">Manage Setup Plan List</span>
                    </nav>
                    
                    <div className="block">
                        <div className="block-header block-header-default">
                            <h3 className="block-title">List of Setup Plan</h3>
                        </div>
                        <div className="block-content">
                            <MDBDataTableV5 
                            hover
                            entriesOptions={[25, 50, 100]}
                            entries={25}
                            pagesAmount={4}
                            span
                            pagingTop
                            searchTop
                            searchBottom={false}
                            barReverse
                            data={this.loadBlogListing()} />
                        </div>
                    </div>    
                </div>
                
                <div id="global_loader" className={_loader}>
                    <div class="gl-ldr-cld">
                        <div class="gl-ldr-ctr">
                            <div class="gl-loader"></div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )    
    }
}